import { useEffect } from "react";
import { useAppDispatch } from "../../app/hooks";
import { Page } from "../../Page";
import styles from './dataDelete.module.css'
import { setHomeButtonVisible, setReloadButtonVisible } from "../menu/menuSlice";
import { BackButton } from "../menu/BackButton";

export function DataDelete() {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setReloadButtonVisible(true))
    dispatch(setHomeButtonVisible(true))
      })
    return (
        <Page>
          <div className={styles.bannerContainer}>
              <div>
                  <h2>PartyPlanner.</h2>
                     <h4>Organise, invite and celebrate in style.</h4>
              </div>
              <div className={styles.bannerButton}>
                  <BackButton/>
              </div>
          </div>
          <div className={styles.content}>
            <h1>PartyPlanner</h1>
             <br></br>
            <h2>Deleting your data</h2>
              <p> We understand if you would no longer like PartyPlanner to store the data you have given to us.
                To delete your data from PartyPlanner, send an email to customer-services@abs.uk.com from the email associated with your PartyPlanner login details. We will then manually delete your data from our database and remove your credentials from our authorisation platform.
                If you wish to use PartyPlanner again you will have to make a new account.
              </p>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
          </div>
        </Page>
    )
}